import React, { useState } from 'react';
import { currency } from '@utils';
import { Table, Button, TableMobile } from '@components';
import { useNavigate } from 'react-router-dom';
import { format, isValid } from 'date-fns';

import { CONTRATOS_ABSOLUTE_PATH } from '../../../../../common/utils/paths';

export const Contrato = ({
  contrato: {
    tipoEmprestimo,
    dtCredito,
    dtCarencia,
    vlrSolicitado,
    vlrIof,
    vlrOperacao,
    txaConcessao,
    vlrCreditado,
    contrato,
    parcPagas,
    parcTotal,
    vlrSaldoDevedor,
    taxaFundo,
    totalParcelasEmAtraso,
    valorTotalEmAtraso,
    ultimaParcela,
    parcelas,
  },
}) => {
  const [isDetailed, setIsDetailed] = useState(false);
  const navigate = useNavigate();

  const desabilitaCarencia = parcPagas >= 12;
  const desabilitaParcelaAtraso = totalParcelasEmAtraso === 0;

  return (
    <>
      <div className="my-32">
        <div>
          <div className="item-contrato-header mb-3">
            <p className="fw-bold ts-18">Contrato: {contrato}</p>
            {isValid(new Date(dtCredito)) && (
              <p className="ts-16 text-muted">
                Creditado em {format(new Date(dtCredito), 'dd/MM/yyyy')}
              </p>
            )}
            <p className="text-end flex-1">{tipoEmprestimo}</p>
          </div>
          <Table
            className="d-none d-md-block mb-4"
            large
            odd
            columns={[
              'Valor',
              'Parcelas',
              'Lançadas',
              'Última',
              'Saldo devedor',
              'Atrasadas',
              'Valor em atraso',
            ]}
          >
            <tr>
              <td className="ts-20">{currency(vlrSolicitado)}</td>
              <td className="ts-20">{parcTotal}</td>
              <td className="ts-20">{parcPagas}</td>
              <td className="ts-20">{currency(ultimaParcela)}</td>
              <td className="ts-20">{currency(vlrSaldoDevedor)}</td>
              <td className="ts-20">{totalParcelasEmAtraso}</td>
              <td className="ts-20">{currency(valorTotalEmAtraso)}</td>
            </tr>
          </Table>
          <TableMobile className="mb-4">
            <div className="col-6">
              <div className="thead">Valor</div>
              <div className="td">{currency(vlrSolicitado)}</div>
            </div>
            <div className="col-6">
              <div className="thead">Parcelas</div>
              <div className="td">{parcTotal}</div>
            </div>
            <div className="col-6">
              <div className="thead">Lançadas</div>
              <div className="td">{parcPagas}</div>
            </div>
            <div className="col-6">
              <div className="thead">Última</div>
              <div className="td">{ultimaParcela}</div>
            </div>
            <div className="col-6">
              <div className="thead">Saldo devedor</div>
              <div className="td">{currency(vlrSaldoDevedor)}</div>
            </div>
            <div className="col-6">
              <div className="thead">Atrasadas</div>
              <div className="td">{totalParcelasEmAtraso}</div>
            </div>
            <div className="col-12">
              <div className="thead">Valor em atraso</div>
              <div className="td">{currency(valorTotalEmAtraso)}</div>
            </div>
          </TableMobile>
        </div>
        <div className="d-block d-md-flex align-items-center">
          {isDetailed && (
            <div className="mb-3 mb-md-0 me-0 ">
              <Button
                style={{ height: 40 }}
                transparent
                color="orange"
                onClick={() => {
                  navigate(
                    `${CONTRATOS_ABSOLUTE_PATH}/${contrato}/prestacoes`,
                    {
                      state: {
                        parcelas,
                      },
                    }
                  );
                }}
              >
                Visualizar prestações
              </Button>
            </div>
          )}

          <div className="ms-0 ms-md-auto">
            <Button
              style={{ height: 40 }}
              transparent
              color="orange"
              onClick={() => {
                setIsDetailed((prev) => !prev);
              }}
            >
              {isDetailed ? 'Esconder' : 'Mostrar'} detalhes e emissão de
              boletos
            </Button>
          </div>
        </div>

        {isDetailed && (
          <>
            <hr className="my-32" />
            <div className="item-contrato">
              <div>
                <h3 className="ts-20 fw-bold mb-32">Detalhes</h3>
                <div className="d-flex ts-16">
                  <div className="me-3">
                    <p className="fw-bold pb-3">IOF</p>
                    <p className="fw-bold pb-3">Taxa</p>
                    <p className="fw-bold pb-3">Taxa do Fundo</p>
                    <p className="fw-bold pb-3">Operação</p>
                    <p className="fw-bold pb-3">Valor creditado</p>
                  </div>
                  <div>
                    <p className="pb-3">{currency(vlrIof)}</p>
                    <p className="pb-3">{txaConcessao}% ao ano</p>
                    <p className="pb-3">{currency(taxaFundo)}</p>
                    <p className="pb-3">{currency(vlrOperacao)}</p>
                    <p className="pb-3">{currency(vlrCreditado)}</p>
                  </div>
                </div>
              </div>
              <div className="flex-1">
                <h3 className="ts-20 fw-bold mb-32">Boletos</h3>
                <div className="d-block d-md-flex align-items-center flex-wrap gap-2">
                  <div className="mb-3 mb-md-0 me-0 ">
                    {/* <Button
                      style={{ height: 40 }}
                      transparent
                      color="orange"
                      onClick={() => {
                        navigate(
                          `${CONTRATOS_ABSOLUTE_PATH}/${contrato}/parcelas`,
                          {
                            state: {
                              parcelas,
                            },
                          }
                        );
                      }}
                    >
                      Parcelas em atraso
                    </Button> */}
                  </div>
                  <div className="mb-3 mb-md-0 me-0 ">
                    <Button
                      style={{ height: 40 }}
                      transparent
                      color="orange"
                      disabled={desabilitaCarencia}
                      onClick={() => {
                        navigate(
                          `${CONTRATOS_ABSOLUTE_PATH}/${contrato}/carencia`,
                          {
                            state: {
                              dtCredito,
                              dtCarencia,
                              vlrSolicitado,
                              vlrIof,
                              vlrOperacao,
                              txaConcessao,
                              vlrCreditado,
                              contrato,

                              parcPagas,
                              parcTotal,
                              vlrSaldoDevedor,
                              taxaFundo,
                              totalParcelasEmAtraso,
                              valorTotalEmAtraso,
                              ultimaParcela,
                            },
                          }
                        );
                      }}
                    >
                      Antecipação de carência
                    </Button>
                  </div>
                  <div className="mb-3 mb-md-0 me-0 ">
                    <Button
                      style={{ height: 40 }}
                      transparent
                      color="orange"
                      onClick={() => {
                        navigate(
                          `${CONTRATOS_ABSOLUTE_PATH}/${contrato}/quitacao`,
                          {
                            state: {
                              dtCredito,
                              dtCarencia,
                              vlrSolicitado,
                              vlrIof,
                              vlrOperacao,
                              txaConcessao,
                              vlrCreditado,
                              contrato,

                              parcPagas,
                              parcTotal,
                              vlrSaldoDevedor,
                              taxaFundo,
                              totalParcelasEmAtraso,
                              valorTotalEmAtraso,
                              ultimaParcela,
                            },
                          }
                        );
                      }}
                    >
                      Quitação
                    </Button>
                  </div>
                  <div className="mb-3 mb-md-0 me-0 ">
                    <Button
                      style={{ height: 40 }}
                      transparent
                      color="orange"
                      onClick={() => {
                        navigate(
                          `${CONTRATOS_ABSOLUTE_PATH}/${contrato}/amortizar`,
                          {
                            state: {
                              dtCredito,
                              dtCarencia,
                              vlrSolicitado,
                              vlrIof,
                              vlrOperacao,
                              txaConcessao,
                              vlrCreditado,
                              contrato,

                              parcPagas,
                              parcTotal,
                              vlrSaldoDevedor,
                              taxaFundo,
                              totalParcelasEmAtraso,
                              valorTotalEmAtraso,
                              ultimaParcela,
                            },
                          }
                        );
                      }}
                    >
                      Amortização
                    </Button>
                  </div>
                  <div className="mb-3 mb-md-0 me-0 ">
                    <Button
                      style={{ height: 40 }}
                      transparent
                      color="orange"
                      onClick={() => {
                        navigate(
                          `${CONTRATOS_ABSOLUTE_PATH}/${contrato}/antecipar`,
                          {
                            state: {
                              vlrSolicitado,
                              parcTotal,
                              parcPagas,
                              ultimaParcela,
                              vlrSaldoDevedor,
                              totalParcelasEmAtraso,
                              valorTotalEmAtraso,
                            },
                          }
                        );
                      }}
                    >
                      Antecipação
                    </Button>
                  </div>
                  <div className="mb-3 mb-md-0 me-0 ">
                    <Button
                      style={{ height: 40 }}
                      transparent
                      disabled={desabilitaParcelaAtraso}
                      color="orange"
                      onClick={() => {
                        navigate(
                          `${CONTRATOS_ABSOLUTE_PATH}/${contrato}/parcelaAtraso`,
                          {
                            state: {
                              dtCredito,
                              dtCarencia,
                              vlrSolicitado,
                              vlrIof,
                              vlrOperacao,
                              txaConcessao,
                              vlrCreditado,
                              contrato,

                              parcPagas,
                              parcTotal,
                              vlrSaldoDevedor,
                              taxaFundo,
                              totalParcelasEmAtraso,
                              valorTotalEmAtraso,
                              ultimaParcela,
                            },
                          }
                        );
                      }}
                    >
                      Parcelas em Atraso
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <hr />
    </>
  );
};
